import {configurationType} from "./types/ConfType";

export const conf: configurationType = {
  api: {
    uri: 'https://cteamchartres.fr/api',
    debug: false
  }
}
